module.exports = __webpack_public_path__ + "img/10.cbb420f9.png";